import { createContext, useContext, useEffect, useState } from "react";

const IntroContext = createContext({ done: true });

export function IntroProvider({ children, enabled = true }) {
  const [done, setDone] = useState(!enabled);
  return <IntroContext.Provider value={{ done, finish: () => setDone(true) }}>{children}</IntroContext.Provider>;
}

export function useIntro() {
  return useContext(IntroContext);
}
